<div class="tile__status" data-testid="tile"
     [ngClass]="{ 'tile__status--active': tile.params.workingStatus,
        'tile__status--inactive': !tile.params.workingStatus }">
    <svg-icon src="/assets/img/icons/fire.svg"
              *ngIf="!tile.params.workingStatus">
    </svg-icon>
    <svg-icon [class]="'tile-fire--company'"
              src="/assets/img/icons/fire_active.svg"
              *ngIf="tile.params.workingStatus">
    </svg-icon>
    <floating-subtitle class="tile__subtitle"
                       [text]="subtitle(205)">
    </floating-subtitle>
    <div class="tile__setting cursor-pointer"
         [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
            width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
            {{ subtitle(3162) }}
        </p>
    </div>
    <div class="hover-area hover-area--full-width"
         (click)="goControl()"
         [ngClass]="{ 'cursor-pointer': tile.elementMenu && tile.menuId !== 0 }"
         *ngIf="tile.params.value >= 0">
    </div>
    <div class="hover hover--full-width bg-dark-shadow box-shadow"
        data-testid="parameters">
        <div class="hover__item color-light font-12">
            <p class="hover__name">{{ subtitle(310) }}</p>
            <p class="hover__value">
                {{ tile.params.value > 100 ? tile.params.value : tile.params.value*82 }}
            </p>
        </div>
    </div>
</div>
